export default {
  'positivePay.header': 'Check Positive Pay Exceptions',
  'positivePay.subheader': '',
  'positivePay.accounts': 'Select Account',
  'positivePay.allAccountsSelected': 'All accounts selected',
  'positivePay.selectedAccounts': '<%=number %> Accounts Selected'
};
